import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import Icon from "../../../../components/Icon";
import { showSuccess, showError } from "../../../../services/toast.service";

const Panel = ({ selectedMembers = [], onDeleteSelected, onClearSelection }) => {
  const handleDeleteSelected = async () => {
    if (!selectedMembers.length) return;
    
    try {
      await onDeleteSelected(selectedMembers);
      showSuccess(`${selectedMembers.length} membre(s) supprimé(s) avec succès`);
      onClearSelection();
    } catch (error) {
      showError('Erreur lors de la suppression des membres');
      console.error(error);
    }
  };

  // Ne pas afficher le panel s'il n'y a pas de membres sélectionnés
  if (!selectedMembers.length) return null;

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedMembers.length} membre{selectedMembers.length > 1 ? 's' : ''} sélectionné{selectedMembers.length > 1 ? 's' : ''}</span>
      </div>
      <div className={styles.btns}>
        <button className={cn("button-stroke-red", styles.button)} onClick={handleDeleteSelected}>
          <Icon name="trash" size="24" />
          <span>Supprimer</span>
        </button>
      </div>
    </div>
  );
};

export default Panel;
